var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import DOMPurify from "dompurify";
import QuestionnaireOrg from "../../../organisms/jsQuestionnaire/jsQuestionnaire";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { SocialAction, SocialFormAction, } from "../../../../redux/actions/job_seeker_questionnaire";
import { createSelector } from "@reduxjs/toolkit";
import { questionnaireTimer } from "../../../../utils/QuestionnaireTimer";
import { getQuestionnaireAttemptVariant, getQuestionnaireProgressWidth, } from "../../../../utils/questionnaireProgress";
// Create memoized selectors
var selectJobSeekerQuestionnaire = function (state) {
    return state.rootReducer.JobSeekerQuestionnaireReducer;
};
var selectUserData = function (state) { return state.rootReducer.userReducer; };
var selectQuestionnaireData = createSelector([selectJobSeekerQuestionnaire], function (questionnaire) { return ({
    socialData: questionnaire.socialData,
    socialFormData: questionnaire.socialFormData,
    status: questionnaire.status,
    success_social_form: questionnaire.success_social_form,
}); });
var selectLoginData = createSelector([selectUserData], function (userData) { return ({
    loginData: userData.loginData || "",
}); });
/**
 * The Social Questionnaire Page
 * This will need to call all relevant APIs to get the values.
 * @returns JSX.Element
 */
function SocialQuestionnaire() {
    var navigate = useNavigate();
    var dispatch = useDispatch();
    var _a = useState(false), isSubmitting = _a[0], setIsSubmitting = _a[1];
    var _b = useSelector(selectQuestionnaireData), socialData = _b.socialData, socialFormData = _b.socialFormData, success_social_form = _b.success_social_form;
    var loginData = useSelector(selectLoginData).loginData;
    var quesAttemptDetails = useSelector(function (state) { return state.rootReducer.dashboardReducer.quesAttemptDetails; });
    useEffect(function () {
        console.log("[Social] Component mounted, fetching data");
        questionnaireTimer.startSection("Health and Social Support");
        // Antecedents prefetches this section already; only fetch if it's
        // not already cached in the store (e.g. direct navigation to this page).
        if (!socialData || socialData.length === 0) {
            dispatch(SocialAction());
        }
    }, [dispatch]);
    var handleFormSubmit = function (formData) {
        console.log("[Social] Submitting form data:", formData);
        questionnaireTimer.endSection("Health and Social Support");
        var sanitizedData = Object.keys(formData).reduce(function (acc, key) {
            acc[key] =
                typeof formData[key] === "string"
                    ? DOMPurify.sanitize(formData[key])
                    : formData[key];
            return acc;
        }, {});
        console.log("[Social] Dispatching form action with sanitized data");
        setIsSubmitting(true);
        dispatch(SocialFormAction(sanitizedData, loginData));
    };
    var handleBackBtn = function () {
        console.log("[Social] Navigating back to qualifications");
        navigate("/questionnaire/qualifications");
    };
    useEffect(function () {
        console.log("[Social] Success status changed:", success_social_form);
        if (success_social_form && isSubmitting) {
            console.log("[Social] Form successful, navigating to personal wellbeing");
            navigate("/questionnaire/personal_wellbeing");
        }
    }, [success_social_form, isSubmitting, navigate]);
    console.log("[Social] Rendering with data:", {
        hasData: !!(socialData === null || socialData === void 0 ? void 0 : socialData.length),
        hasFormData: !!Object.keys(socialFormData || {}).length,
        success: success_social_form,
    });
    return (_jsx("div", __assign({ className: "" }, { children: _jsx(QuestionnaireOrg, { title: "Personal Circumstances", content: "In this section, please tell us about your personal circumstances and the support you have in regard to looking for and keeping work.", data: socialData, responses: socialFormData, loading: !socialData || socialData.length === 0, handleSubmit: handleFormSubmit, handleBackBtn: handleBackBtn, classname: "social-w", width: getQuestionnaireProgressWidth("social", getQuestionnaireAttemptVariant(quesAttemptDetails)) }) })));
}
export default SocialQuestionnaire;
